import React from 'react';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close_2.svg';
import icLoading from 'assets/svg/ic_loading.svg';
import Modal from 'src/Components/Modal';

const ProcessingModal = ({
  onClose,
  content,
  withTitle
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.rotate,
    src: icLoading
  }), /*#__PURE__*/React.createElement("span", null, "Processing...")), withTitle && /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Request in processing"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, content)));
};

export default ProcessingModal;